/**
 * @description Media Type as per MPX metadata.availableForProfileTypes field
 */
export enum MPXAvailableProfileType {
	ADULT = 'ADULT',
	KIDS = 'KIDS',
	YOUNGER_KIDS = 'YOUNGER_KIDS',
}